import { useMutation, useQuery, useQueryClient } from "react-query";
import subscriptionServices from "app/services/subscription-services";

const SUBSCRIPTIONS_QUERY_KEY = ["subscriptions", "overview"];
const SUBSCRIPTIONS_CLIENTS_QUERY_KEY = ["subscriptions", "clients"];
const SUBSCRIPTIONS_CHANGE_REQUESTS_QUERY_KEY = ["subscriptions", "change-requests"];

export const useSubscriptionsOverview = () =>
  useQuery(SUBSCRIPTIONS_QUERY_KEY, subscriptionServices.getOverview);

export const useSubscriptionsClientsOverview = ({ enabled = true } = {}) =>
  useQuery(SUBSCRIPTIONS_CLIENTS_QUERY_KEY, subscriptionServices.getClientsOverview, {
    enabled,
  });

export const useSubscriptionChangeRequests = ({ enabled = true } = {}) =>
  useQuery(SUBSCRIPTIONS_CHANGE_REQUESTS_QUERY_KEY, subscriptionServices.getChangeRequests, {
    enabled,
  });

export const useResolveSubscriptionChangeRequest = () => {
  const queryClient = useQueryClient();

  return useMutation(subscriptionServices.resolveChangeRequest, {
    onSuccess: () => {
      queryClient.invalidateQueries(SUBSCRIPTIONS_CHANGE_REQUESTS_QUERY_KEY);
      queryClient.invalidateQueries(SUBSCRIPTIONS_QUERY_KEY);
      queryClient.invalidateQueries(SUBSCRIPTIONS_CLIENTS_QUERY_KEY);
    },
  });
};

export const useChangeSubscriptionPlan = () => {
  const queryClient = useQueryClient();

  return useMutation(subscriptionServices.changePlan, {
    onSuccess: () => {
      queryClient.invalidateQueries(SUBSCRIPTIONS_QUERY_KEY);
      queryClient.invalidateQueries(SUBSCRIPTIONS_CLIENTS_QUERY_KEY);
      queryClient.invalidateQueries(SUBSCRIPTIONS_CHANGE_REQUESTS_QUERY_KEY);
    },
  });
};

export const useUpdateMembership = () => {
  const queryClient = useQueryClient();

  return useMutation(subscriptionServices.updateMembership, {
    onSuccess: () => {
      queryClient.invalidateQueries(SUBSCRIPTIONS_CLIENTS_QUERY_KEY);
      queryClient.invalidateQueries(SUBSCRIPTIONS_QUERY_KEY);
    },
  });
};
